// Centralized mock data for ValoRex (frontend-only phase)
// NOTE: Replace with real API calls during backend integration

export const PLANS = [
  {
    id: 'free',
    name: 'Free',
    tagline: 'Start your journey',
    priceLabel: '0 PKR',
    priceMonthly: 0,
    slots: 10,
    icon: 'https://media.valorant-api.com/competitivetiers/03621f52-342b-cf4e-4f86-9350a49c6d04/3/largeicon.png',
    color: 'from-zinc-500/30 to-zinc-700/10',
    accent: 'cyan',
    features: [
      '10 Account Slots',
      'Account Details',
      'Account Inventory',
      'Account Store',
      'Shareable Account Links',
      '24h Cooldown on removed slots'
    ],
    cta: 'Get Started'
  },
  {
    id: 'platinum',
    name: 'Platinum',
    tagline: 'More room to manage',
    priceLabel: '499 PKR',
    priceMonthly: 499,
    slots: 200,
    icon: 'https://media.valorant-api.com/competitivetiers/03621f52-342b-cf4e-4f86-9350a49c6d04/16/largeicon.png',
    color: 'from-cyan-400/40 to-blue-600/10',
    accent: 'cyan',
    features: [
      '200 Account Slots',
      'Account Details',
      'Account Inventory',
      'Account Store',
      'Shareable Account Links',
      '12h cooldown on removed slots'
    ],
    cta: 'Upgrade'
  },
  {
    id: 'immortal',
    name: 'Immortal',
    tagline: 'For serious operators',
    priceLabel: '1099 PKR',
    priceMonthly: 1099,
    slots: 600,
    icon: 'https://media.valorant-api.com/competitivetiers/03621f52-342b-cf4e-4f86-9350a49c6d04/24/largeicon.png',
    color: 'from-orange-500/40 to-amber-600/10',
    accent: 'orange',
    features: [
      '600 Account Slots',
      'All perks of Free',
      '90 min cooldown on removed slots',
      'Account Agents view',
      'Control Panel',
      'Priority manual activation'
    ],
    cta: 'Upgrade'
  },
  {
    id: 'radiant',
    name: 'Radiant',
    tagline: 'Top of the leaderboard',
    priceLabel: '2999 PKR',
    priceMonthly: 2999,
    slots: 5000,
    icon: 'https://media.valorant-api.com/competitivetiers/03621f52-342b-cf4e-4f86-9350a49c6d04/27/largeicon.png',
    color: 'from-fuchsia-500/40 to-orange-500/10',
    accent: 'orange',
    features: [
      '5000 Account Slots',
      'All perks of Immortal',
      'No Cooldown',
      'Public Accounts',
      'Public Profile page',
      'VIP support'
    ],
    cta: 'Go Radiant'
  }
];

export const MOCK_USER = {
  id: 'usr_demo_001',
  email: 'operator@valorex.space',
  username: 'NeonOperator',
  avatar: 'https://media.valorant-api.com/playercards/17712b8a-4555-8b65-2bbe-75a288069420/smallart.png',
  plan: 'free',
  planExpiresAt: null,
  createdAt: '2025-07-01T10:00:00Z',
  slotsUsed: 3,
  slotsTotal: 10
};

export const MOCK_ACCOUNTS = [
  {
    id: 'acc_001',
    ign: 'PhantomStrike',
    tag: 'NEON',
    region: 'Europe',
    country: 'Pakistan',
    level: 142,
    rank: { name: 'Diamond 2', tier: 19, icon: 'https://media.valorant-api.com/competitivetiers/03621f52-342b-cf4e-4f86-9350a49c6d04/19/largeicon.png' },
    peakRank: { name: 'Ascendant 1', icon: 'https://media.valorant-api.com/competitivetiers/03621f52-342b-cf4e-4f86-9350a49c6d04/21/largeicon.png' },
    title: 'The Unkillable',
    banner: 'https://media.valorant-api.com/playercards/17712b8a-4555-8b65-2bbe-75a288069420/wideart.png',
    card: 'https://media.valorant-api.com/playercards/17712b8a-4555-8b65-2bbe-75a288069420/smallart.png',
    totalValueVP: 12450,
    skinsCount: 38,
    agentsCount: 23,
    shareSlug: 'PH4n7om',
    status: 'active',
    addedAt: '2025-07-12T09:30:00Z'
  },
  {
    id: 'acc_002',
    ign: 'ViperVenom',
    tag: 'TOXIC',
    region: 'NA',
    country: 'USA',
    level: 87,
    rank: { name: 'Platinum 3', tier: 15, icon: 'https://media.valorant-api.com/competitivetiers/03621f52-342b-cf4e-4f86-9350a49c6d04/15/largeicon.png' },
    peakRank: { name: 'Diamond 1', icon: 'https://media.valorant-api.com/competitivetiers/03621f52-342b-cf4e-4f86-9350a49c6d04/18/largeicon.png' },
    title: 'Radiant Killer',
    banner: 'https://media.valorant-api.com/playercards/3f53b7f4-433d-4dec-9d8b-19e44ad3f7bb/wideart.png',
    card: 'https://media.valorant-api.com/playercards/3f53b7f4-433d-4dec-9d8b-19e44ad3f7bb/smallart.png',
    totalValueVP: 7320,
    skinsCount: 21,
    agentsCount: 18,
    shareSlug: 'V1perV',
    status: 'active',
    addedAt: '2025-07-10T16:10:00Z'
  },
  {
    id: 'acc_003',
    ign: 'JettSlash',
    tag: 'DASH',
    region: 'AP',
    country: 'Japan',
    level: 210,
    rank: { name: 'Immortal 1', tier: 24, icon: 'https://media.valorant-api.com/competitivetiers/03621f52-342b-cf4e-4f86-9350a49c6d04/24/largeicon.png' },
    peakRank: { name: 'Immortal 2', icon: 'https://media.valorant-api.com/competitivetiers/03621f52-342b-cf4e-4f86-9350a49c6d04/25/largeicon.png' },
    title: 'Wind Walker',
    banner: 'https://media.valorant-api.com/playercards/4a7f5b22-b2a7-4cb9-93c9-2b7c9d3f3e11/wideart.png',
    card: 'https://media.valorant-api.com/playercards/4a7f5b22-b2a7-4cb9-93c9-2b7c9d3f3e11/smallart.png',
    totalValueVP: 24800,
    skinsCount: 57,
    agentsCount: 25,
    shareSlug: 'J377x',
    status: 'active',
    addedAt: '2025-07-08T11:22:00Z'
  }
];

export const COOLDOWN_SLOTS = [
  { id: 'cd_1', removedAt: Date.now() - 1000 * 60 * 60 * 6, remainingMs: 1000 * 60 * 60 * 18 },
  { id: 'cd_2', removedAt: Date.now() - 1000 * 60 * 60 * 2, remainingMs: 1000 * 60 * 60 * 22 }
];

export const MOCK_SKINS = [
  { id: 's1', name: 'Reaver Vandal', weapon: 'Vandal', tier: 'Exclusive', price: 2175, img: 'https://media.valorant-api.com/weaponskinlevels/9cdfe68d-43b9-05c4-6fe1-c6be6c0d6a75/displayicon.png' },
  { id: 's2', name: 'Prime Phantom', weapon: 'Phantom', tier: 'Premium', price: 1775, img: 'https://media.valorant-api.com/weaponskinlevels/a800bcd7-4a66-f5f4-4236-f8857c69b3d8/displayicon.png' },
  { id: 's3', name: 'Glitchpop Operator', weapon: 'Operator', tier: 'Premium', price: 2175, img: 'https://media.valorant-api.com/weaponskinlevels/6de9214f-4f71-9abe-e5c5-b39ce1c7fc26/displayicon.png' },
  { id: 's4', name: 'Oni Shorty', weapon: 'Shorty', tier: 'Deluxe', price: 1275, img: 'https://media.valorant-api.com/weaponskinlevels/8cccd59e-41fe-3ce7-7c86-8eac5c6e6b92/displayicon.png' },
  { id: 's5', name: 'Ion Sheriff', weapon: 'Sheriff', tier: 'Premium', price: 1775, img: 'https://media.valorant-api.com/weaponskinlevels/ffbf81d7-429a-d2a8-7df5-018c1cef94b0/displayicon.png' },
  { id: 's6', name: 'RGX 11z Pro Karambit', weapon: 'Melee', tier: 'Premium', price: 4350, img: 'https://media.valorant-api.com/weaponskinlevels/66ae7454-47d6-3299-a3cd-e488ff0e7bbe/displayicon.png' },
  { id: 's7', name: 'Elderflame Vandal', weapon: 'Vandal', tier: 'Ultra', price: 2475, img: 'https://media.valorant-api.com/weaponskinlevels/ab50b07a-4f15-a701-c91c-c8853f0a3e31/displayicon.png' },
  { id: 's8', name: 'Singularity Phantom', weapon: 'Phantom', tier: 'Premium', price: 1775, img: 'https://media.valorant-api.com/weaponskinlevels/df75e0bf-4558-5c39-0f65-efa3b1bdbf3f/displayicon.png' }
];

export const MOCK_AGENTS = [
  { id: 'a1', name: 'Jett', role: 'Duelist', img: 'https://media.valorant-api.com/agents/add6443a-41bd-e414-f6ad-e58d267f4e95/displayicon.png', owned: true },
  { id: 'a2', name: 'Reyna', role: 'Duelist', img: 'https://media.valorant-api.com/agents/a3bfb853-43b2-7238-a4f1-ad90e9e46bcc/displayicon.png', owned: true },
  { id: 'a3', name: 'Phoenix', role: 'Duelist', img: 'https://media.valorant-api.com/agents/eb93336a-449b-9c1b-0a54-a891f7921d69/displayicon.png', owned: true },
  { id: 'a4', name: 'Sage', role: 'Sentinel', img: 'https://media.valorant-api.com/agents/569fdd95-4d10-43ab-ca70-79becc718b46/displayicon.png', owned: true },
  { id: 'a5', name: 'Cypher', role: 'Sentinel', img: 'https://media.valorant-api.com/agents/117ed9e3-49f3-6512-3ccf-0cada7e3823b/displayicon.png', owned: true },
  { id: 'a6', name: 'Omen', role: 'Controller', img: 'https://media.valorant-api.com/agents/8e253930-4c05-31dd-1b6c-968525494517/displayicon.png', owned: true },
  { id: 'a7', name: 'Brimstone', role: 'Controller', img: 'https://media.valorant-api.com/agents/9f0d8ba9-4140-b941-57d3-a7ad57c6b417/displayicon.png', owned: false },
  { id: 'a8', name: 'Sova', role: 'Initiator', img: 'https://media.valorant-api.com/agents/320b2a48-4d9b-a075-30f1-1f93a9b638fa/displayicon.png', owned: true },
  { id: 'a9', name: 'Killjoy', role: 'Sentinel', img: 'https://media.valorant-api.com/agents/1e58de9c-4950-5125-93e9-a0aee9f98746/displayicon.png', owned: false },
  { id: 'a10', name: 'Viper', role: 'Controller', img: 'https://media.valorant-api.com/agents/707eab51-4836-f488-046a-cda6bf494859/displayicon.png', owned: true }
];

export const MOCK_MATCHES = [
  { id: 'm1', map: 'Haven', agent: 'Jett', result: 'Victory', score: '13-8', kda: '24/12/5', mvp: true, date: '2025-07-14' },
  { id: 'm2', map: 'Bind', agent: 'Reyna', result: 'Defeat', score: '10-13', kda: '18/15/3', mvp: false, date: '2025-07-14' },
  { id: 'm3', map: 'Ascent', agent: 'Omen', result: 'Victory', score: '13-11', kda: '15/10/12', mvp: false, date: '2025-07-13' },
  { id: 'm4', map: 'Split', agent: 'Sage', result: 'Victory', score: '13-6', kda: '10/8/18', mvp: true, date: '2025-07-12' },
  { id: 'm5', map: 'Icebox', agent: 'Viper', result: 'Defeat', score: '11-13', kda: '14/16/6', mvp: false, date: '2025-07-11' }
];

export const MOCK_CURRENCIES = {
  vp: 12450,        // Unused Valorant Points
  radianites: 4280, // Radianite Points
  kingdom: 1675,    // Kingdom Credits
};

export const MOCK_REGISTRATION = {
  registeredAt: '2020-06-12T08:14:00Z',
  registeredRegion: 'EU',
  emailVerified: true,
  phoneVerified: false,
  riotId: '43ea006c-decb-5c06-9f0d-d2438fc3b555'
};

export const MOCK_DAILY_SHOP = {
  refreshInMs: 1000 * 60 * 60 * 11 + 1000 * 60 * 23,
  items: [
    { id: 'd1', name: 'Reaver Vandal', weapon: 'Vandal', tier: 'Exclusive', price: 2175, img: 'https://media.valorant-api.com/weaponskinlevels/9cdfe68d-43b9-05c4-6fe1-c6be6c0d6a75/displayicon.png' },
    { id: 'd2', name: 'Ion Sheriff', weapon: 'Sheriff', tier: 'Premium', price: 1775, img: 'https://media.valorant-api.com/weaponskinlevels/ffbf81d7-429a-d2a8-7df5-018c1cef94b0/displayicon.png' },
    { id: 'd3', name: 'Glitchpop Operator', weapon: 'Operator', tier: 'Premium', price: 2175, img: 'https://media.valorant-api.com/weaponskinlevels/6de9214f-4f71-9abe-e5c5-b39ce1c7fc26/displayicon.png' },
    { id: 'd4', name: 'Singularity Phantom', weapon: 'Phantom', tier: 'Premium', price: 1775, img: 'https://media.valorant-api.com/weaponskinlevels/df75e0bf-4558-5c39-0f65-efa3b1bdbf3f/displayicon.png' }
  ]
};

export const MOCK_NIGHT_MARKET = {
  active: false,
  refreshInMs: 1000 * 60 * 60 * 47 + 1000 * 60 * 12,
  items: [
    { id: 'n1', name: 'Prime Phantom', weapon: 'Phantom', original: 1775, price: 980, discount: 45, img: 'https://media.valorant-api.com/weaponskinlevels/a800bcd7-4a66-f5f4-4236-f8857c69b3d8/displayicon.png' },
    { id: 'n2', name: 'Oni Shorty', weapon: 'Shorty', original: 1275, price: 510, discount: 60, img: 'https://media.valorant-api.com/weaponskinlevels/8cccd59e-41fe-3ce7-7c86-8eac5c6e6b92/displayicon.png' },
    { id: 'n3', name: 'Elderflame Vandal', weapon: 'Vandal', original: 2475, price: 1485, discount: 40, img: 'https://media.valorant-api.com/weaponskinlevels/ab50b07a-4f15-a701-c91c-c8853f0a3e31/displayicon.png' },
    { id: 'n4', name: 'RGX 11z Karambit', weapon: 'Melee', original: 4350, price: 1740, discount: 60, img: 'https://media.valorant-api.com/weaponskinlevels/66ae7454-47d6-3299-a3cd-e488ff0e7bbe/displayicon.png' },
    { id: 'n5', name: 'Glitchpop Vandal', weapon: 'Vandal', original: 2175, price: 1305, discount: 40, img: 'https://media.valorant-api.com/weaponskinlevels/ab50b07a-4f15-a701-c91c-c8853f0a3e31/displayicon.png' },
    { id: 'n6', name: 'Reaver Sheriff', weapon: 'Sheriff', original: 1775, price: 710, discount: 60, img: 'https://media.valorant-api.com/weaponskinlevels/ffbf81d7-429a-d2a8-7df5-018c1cef94b0/displayicon.png' }
  ]
};

export const MOCK_BUNDLE = {
  name: 'Glitchpop // 2.0 Collection',
  price: 7100,
  endsInMs: 1000 * 60 * 60 * 24 * 6 + 1000 * 60 * 60 * 11,
  banner: 'https://media.valorant-api.com/bundles/0c322d40-43e3-1c11-3992-388a99fc6d28/displayicon.png',
  items: ['Glitchpop Vandal', 'Glitchpop Bulldog', 'Glitchpop Frenzy', 'Glitchpop Judge', 'Glitchpop Dagger']
};

export const MOCK_INVENTORY_EXTRAS = {
  buddies: [
    { id: 'b1', name: 'Yoru Mask', img: 'https://media.valorant-api.com/buddies/4519d1dd-4e93-f17b-8baa-e191f31e7e08/displayicon.png' },
    { id: 'b2', name: 'Glitchpop Knight', img: 'https://media.valorant-api.com/buddies/dd35d199-44ff-2c13-ec0f-90a1ec22b4f3/displayicon.png' },
    { id: 'b3', name: 'Bound Edition', img: 'https://media.valorant-api.com/buddies/0a8c5ff6-49b6-b1c8-3ac7-4691f80c5f72/displayicon.png' },
    { id: 'b4', name: 'Glitchpop Drone', img: 'https://media.valorant-api.com/buddies/aaa5c6ba-4ba2-7d1c-fcad-c9b4cdcb3f41/displayicon.png' },
    { id: 'b5', name: 'Pixel Heart', img: 'https://media.valorant-api.com/buddies/c08fdf08-44c8-2ad2-ddd1-0fb4ec54bb23/displayicon.png' },
    { id: 'b6', name: 'Yoru\u2019s Letter', img: 'https://media.valorant-api.com/buddies/7d4a7af2-4ec0-b83c-ee61-09a90eaeed01/displayicon.png' }
  ],
  cards: [
    { id: 'c1', name: 'Phantom Card', img: 'https://media.valorant-api.com/playercards/17712b8a-4555-8b65-2bbe-75a288069420/smallart.png' },
    { id: 'c2', name: 'Reaver Card', img: 'https://media.valorant-api.com/playercards/3f53b7f4-433d-4dec-9d8b-19e44ad3f7bb/smallart.png' },
    { id: 'c3', name: 'Glitchpop Card', img: 'https://media.valorant-api.com/playercards/4a7f5b22-b2a7-4cb9-93c9-2b7c9d3f3e11/smallart.png' },
    { id: 'c4', name: 'Ion Card', img: 'https://media.valorant-api.com/playercards/17712b8a-4555-8b65-2bbe-75a288069420/smallart.png' }
  ],
  sprays: [
    { id: 'sp1', name: 'Fade Spray' },
    { id: 'sp2', name: 'GG Brimstone' },
    { id: 'sp3', name: 'Killjoy Wave' },
    { id: 'sp4', name: 'Sage Heal' },
    { id: 'sp5', name: 'Phoenix Flame' },
    { id: 'sp6', name: 'Jett Wind' }
  ],
  titles: [
    { id: 't1', text: 'The Unkillable', equipped: true },
    { id: 't2', text: 'Radiant Killer', equipped: false },
    { id: 't3', text: 'Skill Issue', equipped: false },
    { id: 't4', text: 'Wind Walker', equipped: false },
    { id: 't5', text: 'Operator', equipped: false }
  ],
  flexes: [
    { id: 'f1', text: 'Closed Beta Veteran', tier: 'gold' },
    { id: 'f2', text: 'Episode 1 // Ignition', tier: 'silver' },
    { id: 'f3', text: 'Champions 2022', tier: 'gold' },
    { id: 'f4', text: 'Radiant in Episode 5', tier: 'platinum' },
    { id: 'f5', text: 'Surrender Veteran', tier: 'bronze' }
  ]
};

export const MOCK_RANK_HISTORY = [
  { name: 'DIAMOND 2', episode: 'Episode 9', act: 'ACT III', icon: 'https://media.valorant-api.com/competitivetiers/03621f52-342b-cf4e-4f86-9350a49c6d04/19/largeicon.png' },
  { name: 'DIAMOND 1', episode: 'Episode 9', act: 'ACT II', icon: 'https://media.valorant-api.com/competitivetiers/03621f52-342b-cf4e-4f86-9350a49c6d04/18/largeicon.png' },
  { name: 'PLATINUM 3', episode: 'Episode 9', act: 'ACT I', icon: 'https://media.valorant-api.com/competitivetiers/03621f52-342b-cf4e-4f86-9350a49c6d04/15/largeicon.png' },
  { name: 'ASCENDANT 1', episode: 'Episode 8', act: 'ACT III', icon: 'https://media.valorant-api.com/competitivetiers/03621f52-342b-cf4e-4f86-9350a49c6d04/21/largeicon.png' },
  { name: 'DIAMOND 3', episode: 'Episode 8', act: 'ACT II', icon: 'https://media.valorant-api.com/competitivetiers/03621f52-342b-cf4e-4f86-9350a49c6d04/20/largeicon.png' },
  { name: 'DIAMOND 1', episode: 'Episode 8', act: 'ACT I', icon: 'https://media.valorant-api.com/competitivetiers/03621f52-342b-cf4e-4f86-9350a49c6d04/18/largeicon.png' }
];

export const MOCK_ADMIN_USERS = [
  { id: 'u1', email: 'alpha@valorex.space', username: 'AlphaWolf', plan: 'radiant', status: 'active', planExpiresAt: '2025-08-15T00:00:00Z', accountsUsed: 340, createdAt: '2025-06-01' },
  { id: 'u2', email: 'bravo@valorex.space', username: 'BravoTango', plan: 'immortal', status: 'active', planExpiresAt: '2025-07-30T00:00:00Z', accountsUsed: 112, createdAt: '2025-06-14' },
  { id: 'u3', email: 'charlie@valorex.space', username: 'Charlie27', plan: 'free', status: 'active', planExpiresAt: null, accountsUsed: 4, createdAt: '2025-06-20' },
  { id: 'u4', email: 'delta@valorex.space', username: 'DeltaForce', plan: 'immortal', status: 'pending', planExpiresAt: null, accountsUsed: 0, createdAt: '2025-07-14' },
  { id: 'u5', email: 'echo@valorex.space', username: 'EchoShade', plan: 'radiant', status: 'pending', planExpiresAt: null, accountsUsed: 0, createdAt: '2025-07-15' },
  { id: 'u6', email: 'foxtrot@valorex.space', username: 'FoxNeon', plan: 'free', status: 'active', planExpiresAt: null, accountsUsed: 9, createdAt: '2025-06-25' }
];

export const MOCK_PAYMENTS = [
  { id: 'p1', userEmail: 'delta@valorex.space', plan: 'immortal', amount: 1200, method: 'JazzCash', reference: 'JC-8829-112', status: 'pending', submittedAt: '2025-07-14T18:22:00Z' },
  { id: 'p2', userEmail: 'echo@valorex.space', plan: 'radiant', amount: 3000, method: 'Easypaisa', reference: 'EP-55441-9', status: 'pending', submittedAt: '2025-07-15T09:05:00Z' },
  { id: 'p3', userEmail: 'alpha@valorex.space', plan: 'radiant', amount: 3000, method: 'Bank Transfer', reference: 'HBL-772-AA2', status: 'approved', submittedAt: '2025-06-01T10:22:00Z' }
];
